import { useMemo } from "react";

import { StatusRefund } from "@/lib/gql/__generated__/graphql";

import { EditGuideTooltip } from "@/components/features/items/edit/_shared/ui/components/system/tooltip/edit-guide-tooltip";

import { Label } from "@/components/ui/label/label";

type Props = {
	statusRefund?: StatusRefund | null;
};

export const RefundStatusOfManagementStatusCompositions = ({ statusRefund }: Props) => {
	/**
	 * 返金処理が審査中かどうか
	 */
	const isRefundPending = useMemo(() => {
		return statusRefund === StatusRefund.Pending;
	}, [statusRefund]);
	/**
	 * 返金処理が承認済みかどうか
	 */
	const isRefundApproval = useMemo(() => {
		return statusRefund === StatusRefund.Approval;
	}, [statusRefund]);
	/**
	 * 返金処理が非承認かどうか
	 */
	const isRefundRejected = useMemo(() => {
		return statusRefund === StatusRefund.Rejected;
	}, [statusRefund]);

	return (
		<div className="w-full space-y-2">
			<div className="flex items-center gap-2">
				<p>返金処理のステータス</p>

				<EditGuideTooltip
					guide={`
          <b>返金処理について</b>
          <br />
          チェックアウト日以降 にCHILLNNでの審査を通して、お客様に対して返金できる機能です。
          <br />
          お客様に対して返金したい場合は「予約に対する操作/返金処理を申請する」から、返金希望金額と返金理由を入力の上、ご申請ください。
          <br /><br />
          <b>「承認」された場合</b>
          <br />
          承認され次第、迅速に返金処理が実行されます。
          <br /><br />
          <b>「非承認」の場合</b>
          <br />
          CHILLNNからの「非承認理由」が施設様に送られます。
        `}
				/>
			</div>

			<div className="flex flex-wrap gap-2">
				<Label text="審査中" variant={isRefundPending ? "green" : "black"} />

				<Label text="承認" variant={isRefundApproval ? "link" : "black"} />

				<Label text="非承認" variant={isRefundRejected ? "required" : "black"} />
			</div>
		</div>
	);
};
